import { queryOptions, useQuery } from '@tanstack/react-query';

import { auctionsApi } from '../api/auctions-api';
import { pollInterval } from '../schemas/auction-rules';

import { auctionKeys } from './auction-keys';

/** Polls every few seconds while the auction is live, so bids show up without a reload. */
export function auctionQueryOptions(storeId: string, id: string) {
  return queryOptions({
    queryKey: auctionKeys.detail(storeId, id),
    queryFn: () => auctionsApi.get(storeId, id),
    refetchInterval: (query) => pollInterval(query.state.data),
  });
}

export function useAuction(storeId: string, id: string) {
  return useQuery(auctionQueryOptions(storeId, id));
}
